import apiClient from './axios.config';
import { isUnauthorized } from './utils/error-handler';
import type { SessionDto } from '../types';

export const sessionApi = {
  /**
   * Get all active sessions for current user
   */
  getSessions: async (): Promise<SessionDto[]> => {
    const response = await apiClient.get<SessionDto[]>('/auth/sessions');
    return response.data;
  },

  /**
   * Logout from current session
   */
  logoutCurrent: async (): Promise<void> => {
    try {
      await apiClient.post('/auth/logout');
    } catch (error: unknown) {
      // If backend returns 401, it means token was already revoked - treat as success
      if (isUnauthorized(error)) {
        return;
      }
      throw error;
    }
  },

  /**
   * Logout from all sessions except current
   */
  logoutOther: async (): Promise<void> => {
    await apiClient.post('/auth/logout/other');
  },

  /**
   * Logout from all sessions including current
   */
  logoutAll: async (): Promise<void> => {
    await apiClient.post('/auth/logout/all');
  },

  /**
   * Logout from specific session by tokenId
   */
  logoutSession: async (tokenId: string): Promise<void> => {
    try {
      await apiClient.post(`/auth/logout/${tokenId}`);
    } catch (error: unknown) {
      // If backend returns 401, it means token was already revoked - treat as success
      if (isUnauthorized(error)) {
        return;
      }
      throw error;
    }
  },
};
